//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Response$NewsletterController_getCampaigns$Status$200,
  ResponseContentType$NewsletterController_getCampaigns,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useNewsletterController_getCampaigns = (options?: {
  config?: QueryOptions<
    Response$NewsletterController_getCampaigns$Status$200[ResponseContentType$NewsletterController_getCampaigns]
  >;
}) =>
  useApiClient<
    never,
    Response$NewsletterController_getCampaigns$Status$200[ResponseContentType$NewsletterController_getCampaigns]
  >({
    method: 'NewsletterController_getCampaigns',
    config: options?.config,
  });
